import { render, staticRenderFns } from "./vacantResultsDetail.vue?vue&type=template&id=b94e9a80&scoped=true&"
import script from "./vacantResultsDetail.vue?vue&type=script&lang=js&"
export * from "./vacantResultsDetail.vue?vue&type=script&lang=js&"
import style0 from "./vacantResultsDetail.vue?vue&type=style&index=0&id=b94e9a80&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b94e9a80",
  null
  
)

export default component.exports